import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { IMediaResource } from "../types";

export type IMediaSecuredQueryParameters = {
    media?: RelationalValue<IMediaResource>;
};

export type IMediaSecuredQueryResult = IMediaResource;

export const mediaSecuredQuery: IApiQueryFunction<IMediaSecuredQueryParameters> = ({ media }) => {
    if (!media) {
        return;
    }

    return {
        method: "GET",
        url: `/media_secureds/${mapRelationalValue(media)}`,
    };
};

export const useMediaSecuredQuery = createApiQueryHook<IMediaSecuredQueryParameters, IMediaSecuredQueryResult>(
    mediaSecuredQuery,
);
